export const PageHeaders = {
    vehicle: { header: "layout.adminTools", sub_header: "layout.vehicleList" }
}
